  export class cIOMAPPEDCOUNTER {
    number: number = 0;
    inuse: boolean = false;
    counts: number = 0;
    active: number = 0;
  }

  export interface CounterStatus {
    cIO_MAPPED_COUNTER: cIOMAPPEDCOUNTER[];
  }
